<script>
    let html = `
    Data: 24/02/2022<br>
    Cliente: Xivio
    ---------------------
    Produto     qtd     preço   Total
    Azzaro edt 100ml
                10      15,99  150,99
    `
        //import Layout from '../layouts/main'
        //import PageHeader from '@/components/page-header'
    
        export default {
            //components: { Layout, PageHeader },
            components: { },
            data() {
                return {
                    texto:html
                }
            },
        }
    </script>
    
    <template>
        <div>
            <h1>venda</h1>
            <p>{{texto}}</p>

        </div>
    </template>